import BaseAPI from '../../base'
import { apis, getApiUrl } from '../api-config'
/**
 * API xử lý lớp học
 */
class ClassroomAPI extends BaseAPI {}

export default new ClassroomAPI('v1/student-classrooms', 'StudentClassroom', getApiUrl(apis.StudentAPI))
